import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-purple/theme.css';
import { ReportHeader } from '../../header/report-header';
import { CustomTag } from '../../../../components/CustomTag/CustomTag';
import Colors from '../../../../utils/colors';
import { FinancialDebtSideBarFilter } from './side-bar-filter/financial-debt-side-bar-filter';
import { Chart } from 'primereact/chart';
import { FinancialDebtSideBarFilterDatamodel } from './side-bar-filter/financial-debt-side-bar-filter-datamodel';
import { getStudentFinancialDeptOperation } from './operations/get-student-financial-dept-operation';
import { StudentFinancialDept } from '../../../../api/types/reports/finanace/student-financial-dept';
import { getProgramStudentStatusDisplayText } from '../../../../api/types/programs/students/program-student-status';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { PhoneNumberComponent } from '../../../../utils/international-to-israeli';

export const StudentsFinancialDept = () => {
  const [filters, setFilters] = useState<FinancialDebtSideBarFilterDatamodel>();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<StudentFinancialDept[]>([]);

  const fetchData = async (filters: FinancialDebtSideBarFilterDatamodel) => {
    setFilters(filters);
    await getStudentFinancialDeptOperation(filters, setData, setLoading);
  };

  /*useEffect(() => {
    fetchData({})
  }, [])*/

  const getDebtStyle = (debt: number) => {
    if (debt >= 10000) return { color: Colors.dangerText2, fontWeight: 'bold' };
    if (debt >= 5000)
      return { color: Colors.warningYelloText, fontWeight: 'bold' };

    return { color: Colors.approveText2, fontWeight: 'bold' };
  };

  const getStatusSeverity = (status: string) => {
    const severityMap: { [key: string]: 'success' | 'warning' | 'danger' } = {
      פעיל: 'success',
      בהתראה: 'warning',
      בהשעיה: 'danger',
    };
    return severityMap[status] || 'info';
  };

  // Prepare chart data from individual students
  const chartData = {
    labels: data.map((student) => `${student.firstName} ${student.lastName}`),
    datasets: [
      {
        label: 'סכום חוב',
        backgroundColor: Colors.warningYelloText,
        data: data.map(
          (student) => student.totalTuitionFee - student.amountPaid,
        ),
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            return `סכום חוב: ₪${context.raw.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            return `₪${value.toLocaleString()}`;
          },
          padding: 0,
        },
        grid: {
          drawBorder: false,
        },
        border: {
          display: false,
        },
      },
      x: {
        ticks: {
          font: {
            size: 11,
          },
          padding: 0,
        },
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
    },
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ReportHeader
        title="דו״ח חובות שכר לימוד"
        description="דו״ח זה מציג מידע מקיף על חובות כספיים של תלמידים בכל התכניות. הדו״ח כולל פרטי קשר של התלמידים, מידע על תכנית הלימודים וסכומי החוב."
        metadata={[
          { label: 'מטרת הדו״ח', value: 'מעקב אחר חובות כספיים' },
          { label: 'תדירות עדכון', value: 'יומי' },
        ]}
        category="financial"
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        <div
          style={{
            height: 'calc(100vh - 230px)',
            minHeight: '100%',
            width: '300px',
            minWidth: '250px',
          }}
        >
          <FinancialDebtSideBarFilter onSearch={fetchData} />
        </div>

        {/* Main Content Section */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          {/* Charts Section */}
          <div
            style={{
              width: '100%',
              maxHeight: '200px',

              padding: '4px',
              backgroundColor: 'white',
              borderRadius: '6px',
              boxShadow:
                '0 2px 1px -1px rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 1px 3px 0 rgba(0,0,0,0.12)',
            }}
          >
            <div
              className="text-xl font-bold"
              style={{ textAlign: 'right', padding: '0.25rem 0.5rem' }}
            >
              סטטיסטיקת חובות לפי סטודנט
            </div>
            <Chart type="bar" data={chartData} options={chartOptions} />
          </div>

          {/* Table Section */}
          <DataTable
            value={data}
            paginator
            rows={10}
            rowHover
            rowClassName={() => 'cursor-pointer'}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage={
              <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
            }
            dataKey="id"
            scrollable
            scrollHeight="calc(100vh - 300px)"
            tableStyle={{
              direction: 'rtl',
            }}
            className="financial-debt-table"
          >
            <Column
              field="branchName"
              header="שלוחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="firstName"
              header="שם פרטי"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="lastName"
              header="שם משפחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="nationalId"
              header="ת.ז"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="phoneNumber"
              header="טלפון נייד"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData: UserSummaryType) => (
                <PhoneNumberComponent phoneNumber={rowData.phoneNumber} />
              )}
            />
            <Column
              field="email"
              header="כתובת דוא״ל"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="abstractProgramName"
              header="תוכנית לימודים"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="programStartYear"
              header="שנת התחלה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="annualSerialProgramNumber"
              header="מספר תוכנית שנתי"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="programStudentStatus"
              header="סטטוס בתוכנית הלימודים"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData: StudentFinancialDept) => (
                <CustomTag
                  width={'70px'}
                  text={getProgramStudentStatusDisplayText(
                    rowData.programStudentStatus,
                  )}
                  severity={getStatusSeverity(rowData.programStudentStatus)}
                />
              )}
            />
            <Column
              field="debtAmount"
              header="סכום חוב"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData: StudentFinancialDept) => (
                <span style={getDebtStyle(rowData.totalTuitionFee)}>
                  {`₪${rowData.totalTuitionFee - rowData.amountPaid}`}
                </span>
              )}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};
